import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

//** CSS */
import '../../css/mainLayout.css';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import footer_logo from '../../assets/img/footer_logo.png';
import { dictionaryList } from '../../languages/index';

// core components
import Header from '../../components/header/Header';
import SectionPersonal from '../../views/SectionPersonal/SectionPersonal';
import SectionGoals from '../../views/SectionGoals/SectionGoals';
import SectionAssets from '../../views/SectionAssets/SectionAssets';
import SectionPassives from '../../views/SectionPassives/SectionPassives';
import SectionTotalPatrimony from '../../views/SectionTotalPatrimony/SectionTotalPatrimony';
import SectionIncomes from '../../views/SectionIncomes/SectionIncomes';
import SectionExpenses from '../../views/SectionExpenses/SectionExpenses';
import TotalSavingCapacity from '../../views/TotalSavingCapacity/TotalSavingCapacity';
import Results from '../../views/Results/Results';
import PersonalStoreContext from '../../stores/PersonalStore';
import mainBannerEs from '../../assets/img/main_banner.jpg';
import mainBannerEn from '../../assets/img/main_banner_en.jpg';
import resultBannerEs from '../../assets/img/result_banner.png';
import resultBannerEn from '../../assets/img/result_banner_en.png';

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  active: {
    '& $line': {
      borderColor: '#784af4'
    }
  },
  completed: {
    '& $line': {
      borderColor: '#784af4'
    }
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },
  active: {
    color: '#784af4'
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18
  }
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();

  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)'
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    width: '90%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

function getSteps() {
  return ['1', '2', '3', '4', '5', '6'];
}

function getStepContent(step, activeLanguage) {
  switch (step) {
    case 0:
      return <SectionPersonal lang={activeLanguage} />;
    case 1:
      return <SectionGoals lang={activeLanguage} />;
    case 2:
      return <SectionAssets lang={activeLanguage} />;
    case 3:
      return (
        <>
          <SectionPassives lang={activeLanguage} />
          <SectionTotalPatrimony lang={activeLanguage} />
        </>
      );
    case 4:
      return <SectionIncomes lang={activeLanguage} />;
    case 5:
      return (
        <>
          <SectionExpenses lang={activeLanguage} />
          <TotalSavingCapacity lang={activeLanguage} />
        </>
      );
    default:
      return 'Unknown step';
  }
}

const Main = () => {
  const classes = useStyles();
  const steps = getSteps();
  const [activeStep, setActiveStep] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [getImages, setGetImages] = React.useState(false);
  const personalStore = useContext(PersonalStoreContext);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [messageSnack, setMessageSnack] = React.useState('');
  const [activeLanguage, setActiveLanguage] = useState(dictionaryList.es);

  const handleClose = () => {
    setOpen(false);
  };

  const validFullName = () => {
    if (personalStore.name === null || personalStore.name === '') {
      personalStore.setValue('valFullName', {
        error: true,
        message: activeLanguage.optionValidateName
      });
      return false;
    }
    return true;
  };

  const validEmail = () => {
    if (personalStore.email === null || personalStore.email === '') {
      personalStore.setValue('valEmail', {
        error: true,
        message: activeLanguage.optionEmailRequired
      });
      return false;
    }
    if (!validateEmail(personalStore.email.trim().toLowerCase())) {
      personalStore.setValue('valEmail', {
        error: true,
        message: activeLanguage.optionValidateEmail
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (activeStep === 0) {
      const valFullName = validFullName();
      const valEmail = validEmail();
      if (valFullName && valEmail) {
        setActiveStep(prevActiveStep => prevActiveStep + 1);
      } else {
        setMessageSnack(activeLanguage.optionEmailMessage);
        setOpenSnack(true);
      }
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMessageSnack('');
    setOpenSnack(false);
  };

  const handleLangSelector = e => {
    setActiveLanguage(e.target.value === 'es' ? dictionaryList.es : dictionaryList.en);
  };

  return (
    <>
      <Header lang={activeLanguage.lang} handleLangSelector={handleLangSelector} />

      <div>
        {activeStep === steps.length ? (
          <img
            src={activeLanguage.lang === 'es' ? resultBannerEs : resultBannerEn}
            className="main-banner"
            alt="Trusted advisors"
          />
        ) : (
          <img
            src={activeLanguage.lang === 'es' ? mainBannerEs : mainBannerEn}
            className="main-banner"
            alt="Trusted advisors"
          />
        )}
      </div>
      <div className="main-container">
        <div>
          <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>

        {activeStep === steps.length ? (
          <div>
            <div>
              <Results
                getImages={getImages}
                setGetImages={setGetImages}
                setOpen={setOpen}
                lang={activeLanguage}
              />
              <br />
            </div>

            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {'Su diagnóstico ha sido envíado por correo'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Puede contactarnos en nuestro sitio web o agendar un reunion con nuestros
                  especialistas para realizar una visita.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cerrar
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                  Aceptar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        ) : (
          <div>
            <div>{getStepContent(activeStep, activeLanguage)}</div>
            <div style={{ marginTop: '30px' }}>
              <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                {activeLanguage.optionBack}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
              >
                {activeStep === steps.length - 1
                  ? activeLanguage.optionComplete
                  : activeLanguage.optionNext}
              </Button>
            </div>
          </div>
        )}
      </div>

      <a href="https://www.tadvisorsgroup.com">
        <img
          src={footer_logo}
          style={{
            width: '270px',
            marginTop: '-30px'
          }}
          alt="Trusted Advisors, Inc."
        />
      </a>

      <div
        style={{
          lineHeight: '6px',
          fontSize: '14px',
          fontStyle: 'italic',
          color: '#909090'
        }}
      >
        <p>
          {activeLanguage.lang === 'en' &&
            'P. H. Torre Aseguradora Ancón, 21st Floor, Costa del Este, Panama City'}
        </p>
        <p>{activeLanguage.lang === 'es' ? 'Tel: (507) 203-3880' : 'Telephone (507) 203-3880'}</p>
        <p>E-mail: asesores@trustedadvisorspty.com</p>
        <p>www.tadvisorsgroup.com</p>
      </div>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={openSnack}
        autoHideDuration={5000}
        onClose={handleCloseSnack}
        message={messageSnack}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnack}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </>
  );
};

export default Main;
